"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _components = require("components");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var container = (0, _glamor.css)({
  display: "flex"
});

var icon = (0, _glamor.css)({
  display: "inline-block",
  verticalAlign: "top"
});

var rest = (0, _glamor.css)({
  display: "inline-block",
  verticalAlign: "top"
}, (0, _polyfluid.polyfluid)({
  marginLeft: {
    smallMedium: [1, 1.406],
    large: [1.406, 1.875]
  }
}));

var title = (0, _glamor.css)({
  display: "block",

  color: _css.colors.white,
  lineHeight: 1.3
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    smallMedium: 1,
    large: [1, 1.125]
  },
  marginTop: {
    smallMedium: 0.281,
    large: [0.281, 0.375]
  },
  marginBottom: {
    smallMedium: 0.281,
    large: [0.281, 0.375]
  }
}));

var buttons = (0, _glamor.css)({
  marginLeft: (0, _css.unitRem)(-0.25)
});

var subtitle = (0, _glamor.css)({
  lineHeight: 1.3,
  color: _css.colors.gray,

  ":before": {
    content: '"("'
  },

  ":after": {
    content: '")"'
  }
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    smallMedium: 1,
    large: [1, 1.125]
  },
  marginLeft: {
    smallMedium: 0.89,
    large: [0.89, 1.1875]
  }
}));

var ulStyle = (0, _glamor.css)({
  marginLeft: (0, _css.unitRem)(0.7),
  marginBottom: (0, _css.unitRem)(1.6)
});

var listItem = (0, _glamor.css)({
  listStyleType: "disc",
  color: _css.colors.lightGray,
  textDecoration: "underline",

  "& span": {
    paddingLeft: 0,
    marginLeft: 0
  },

  "& a": {
    color: _css.colors.lightGray,
    paddingLeft: 0,
    marginLeft: 0
  }
});

var buttonCss = (0, _glamor.css)({
  ":not(:first-child):before": {
    content: '""',
    display: "inline-block",
    verticalAlign: "middle",

    width: 1,
    height: "1rem",

    marginLeft: (0, _css.unitRem)(0.5),
    marginRight: (0, _css.unitRem)(0.5),
    textAlign: "left",
    background: "#404040",
    "& button": {
      textAlign: "left"
    },
    "& a": {
      textAlign: "left"
    },
    "& span": {
      textAlign: "left"
    }
  }
});

var AccountOption = function AccountOption(props) {
  return _react2.default.createElement(
    "div",
    { className: container },
    _react2.default.createElement(
      "div",
      { className: icon },
      props.icon
    ),
    _react2.default.createElement(
      "div",
      { className: rest },
      _react2.default.createElement(
        "span",
        { className: (0, _glamor.css)(title, props.titleClassName) },
        props.title,
        props.subtitle && _react2.default.createElement(
          "span",
          { className: (0, _glamor.css)(subtitle, props.subtitleClassName) },
          props.subtitle
        ),
        " "
      ),
      props.itemList && _react2.default.createElement(
        "ul",
        { className: ulStyle },
        props.itemList.map(function (item) {
          return _react2.default.createElement(
            "li",
            { className: listItem },
            _react2.default.createElement(_components.TextButtonLibrary, { mode: "small", label: item.label, to: item.link })
          );
        })
      ),
      _react2.default.createElement(
        "div",
        { className: buttons },
        props.buttons && props.buttons.map(function (button) {
          return _react2.default.createElement(_components.TextButtonLibrary, (0, _extends3.default)({ className: buttonCss }, button, { mode: "small" }));
        })
      )
    )
  );
};

exports.default = AccountOption;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AccountOption/AccountOption.js
// module id = 2865
// module chunks = 0